// extracted by mini-css-extract-plugin
module.exports = {"rowVariable":"style_rowVariable__2L325","rowContainer":"style_rowContainer__1CT85","name":"style_name__3LNBN","dynamics":"style_dynamics__1flgR","icon":"style_icon__1Bgus"};